//#region imports
import React from 'react';

// redux
import { useSelector } from "react-redux";
import { selectTimelineIndex, selectThirtyMinLayout } from "_redux/slices/timeline/timeline-control";
import { selectUsedTheme } from '_redux/slices/timeline/theme';

// constants
import { EmployeeInformationColumnWidth, Timeline30MinLayoutColumnWidth, minute30MinLayoutWidth } from '../timeline-constants';

// styling
import { Colors } from "_styles";

//#endregion

const TimelineHourRow = (props) => {

    const timeIndex = useSelector(selectTimelineIndex);             // timeline index (based on 30 min mode or hour mode)
    const intervals = Array.from({ length: 6 });                    // 6 intervals for 5-minute blocks in 30 minutes
    const thirtyMinLayout = useSelector(selectThirtyMinLayout);     // get layout mode from redux
    const usedTheme = useSelector(selectUsedTheme);                 // theme for background color


    // console.log('timeIndex', timeIndex);

    return (
        // Outer wrapper: sticky top for vertical scroll, full width for horizontal scroll
        <div style={{
            display: 'flex',
            position: 'sticky',
            top: 0,
            zIndex: 255,
            backgroundColor: usedTheme?.BACKGROUND_COLOR || '#fff',
            width: 'fit-content',
            minWidth: '100%',
            //borderStyle:'solid', borderWidth:1,
        }}>

            {/* employee information spacer (need to put space between area where employees list is and where clock should start) */}
            <div style={{ minWidth: EmployeeInformationColumnWidth, maxWidth: EmployeeInformationColumnWidth }} />

            {/* hours container */}
            <div style={{
                display: 'flex',
            }}>
                {timeIndex.map((hour, index) => (
                    <div
                        key={index}
                        style={{
                            minWidth: Timeline30MinLayoutColumnWidth,
                            maxWidth: Timeline30MinLayoutColumnWidth,
                            padding: 0,
                            margin: 0,
                            //backgroundColor: Colors.PRM_LIGHT_BLUE
                            //borderStyle:'solid', borderWidth:1,
                            alignItems: 'flex-start',
                            justifyContent: 'flex-start',
                            textAlign: 'left',
                        }}
                    >

                        {/* hour label */}
                        <p style={{
                            textAlign: thirtyMinLayout ? 'left' : 'center',
                            color: Colors.PRM_LIGHT_BLUE,
                            fontSize: '14px',
                            fontWeight: 'bold',
                            padding: 0,
                            margin: 0,
                            marginLeft: -15
                        }}>{hour}</p>

                        {/* intervals container */}
                        <div style={{ display: 'flex', border: '1.5px solid lightgrey' }}>

                            {/* only map intervals if in 30 min layout */}
                            {thirtyMinLayout && intervals.map((_, idx) => (
                                <div key={idx} style={{ width: minute30MinLayoutWidth * 5 }}>
                                    {
                                        // no line on first interval
                                        idx == 0 ?
                                            <p></p>
                                            :
                                            // big line on middle interval
                                            idx == 3 ?
                                                <div style={{ height: '100%', width: '1.5px', backgroundColor: 'lightgrey' }} />
                                                :
                                                // normal length line for other intervals
                                                <div style={{ height: '50%', width: '1.5px', backgroundColor: 'lightgrey' }} />
                                    }
                                </div>
                            ))}
                        </div>

                    </div>
                ))}
            </div>
        </div>
    );
};


// prevent rerender unless timeline index changes
export default React.memo(TimelineHourRow);